/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    isIndex: true,
    index: "I",
    title: "Tiền lãi dầu khí đối với dầu khí xuất bán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[26]",
    index: "1",
    title: "Sản lượng dầu, khí xuất bán trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[27]",
    index: "2",
    title: "Sản lượng dầu thô, khí thiên nhiên xuất bán quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[28]",
    index: "3",
    title: "Hệ số quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[29]",
    index: "4",
    unit: "USD",
    title: "Giá bán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[30]",
    index: "5",
    unit: "USD",
    title: "Doanh thu xuất bán trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[31]",
    index: "6",
    unit: "USD",
    title: "Thuế tài nguyên phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[32]",
    index: "7",
    unit: "USD",
    title: "Thuế xuất khẩu/Thuế đặc biệt phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[33]",
    index: "8",
    unit: "USD",
    title: "Số phụ thu phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[34]",
    index: "9",
    unit: "USD",
    title: "Các loại thuế khác (nếu có)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[35]",
    index: "10",
    unit: "USD",
    title: "Chi phí để lại theo thực tế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[36]",
    index: "11",
    unit: "USD",
    title: "Chi phí khác",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[37]",
    index: "12",
    unit: "USD",
    title: "Lợi nhuận trước thuế [37]=[30]-[31]-...-[36]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[38]",
    index: "13",
    unit: "%",
    title: "Thuế suất thuế TNDN",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[39]",
    index: "14",
    unit: "USD",
    title: "Thuế TNDN phải nộp [39]=[37]x[38]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[40]",
    index: "15",
    unit: "",
    title: "Lợi nhuận sau thuế theo quyết toán [40]=[37]-[39]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[41]",
    index: "16",
    unit: "%",
    title: "Tỷ lệ chia cho nước chủ nhà",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[42]",
    index: "17",
    unit: "USD",
    title: "Lãi dầu, khí được chia của nước chủ nhà theo quyết toán [42]=[40]x[41]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[43]",
    index: "17.1",
    unit: "%",
    title: "Tỷ lệ (%) nộp ngân sách",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[44]",
    index: "17.2",
    unit: "%",
    title: "Tỷ lệ (%) để lại Công ty mẹ - PVN",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[45]",
    index: "17.3",
    unit: "USD",
    title: "Số tiền lãi phải nộp ngân sách theo quyết toán [45] = [42]x[43]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[46]",
    index: "17.4",
    unit: "USD",
    title: "Số tiền nộp về Công ty mẹ - PVN [46] = [42]x[44]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    isIndex: true,
    index: "II",
    title: "Tiền lãi dầu khí đối với tiền kết dư",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[47]",
    index: "1",
    title: "Số tiền kết dư của phần dầu khí để lại",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[47a]",
    index: "1.1",
    unit: "USD",
    title: "Tiền kết dư phần dầu khí để lại theo giá kế hoạch không sử dụng hết",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[47b]",
    index: "1.2",
    unit: "USD",
    title: "Tiền kết dư phần chênh lệch giá dầu khí thực tế cao hơn giá kế hoạch",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[48]",
    index: "2",
    unit: "USD",
    title: "Số phụ thu phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[49]",
    index: "3",
    unit: "USD",
    title: "Thuế TNDN phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[50]",
    index: "4",
    unit: "USD",
    title: "Lợi nhuận sau thuế [50]=[47]-[48]-[49]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[51]",
    index: "5",
    unit: "%",
    title: "Tỷ lệ chia cho nước chủ nhà",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[52]",
    index: "6",
    unit: "USD",
    title: "Tiền lãi dầu, khí được chia của nước chủ nhà [52]=[50]x[51]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[53]",
    index: "6.1",
    unit: "%",
    title: "Tỷ lệ (%) nộp ngân sách",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[54]",
    index: "6.2",
    unit: "%",
    title: "Tỷ lệ (%) để lại Công ty mẹ - PVN",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[55]",
    index: "6.3",
    unit: "USD",
    title: "Số tiền nộp trực tiếp vào ngân sách [55] = [52]x[53]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[56]",
    index: "6.4",
    unit: "USD",
    title: "Số tiền nộp về Công ty mẹ - PVN [56] = [52]x[54]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[57]",
    index: "III",
    unit: "USD",
    title: "Lãi dầu, khí phải nộp ngân sách [57]=[45]+[55]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[58]",
    index: "IV",
    title: "Số tiền lãi dầu, khí tạm tính đã kê khai trong kỳ tính thuế",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[59]",
    index: "V",
    unit: "USD",
    title:
      "Chênh lệch giữa số tiền còn phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế [59] = [57] - [58]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[60]",
    index: "VI",
    unit: "VND/USD",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) =>
    [
      "[37]",
      "[39]",
      "[40]",
      "[42]",
      "[45]",
      "[46]",
      "[47]",
      "[50]",
      "[52]",
      "[55]",
      "[57]",
      "[57]",
      "[59]",
    ].includes(spendId) || !spendId;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: !item.spendId ? 800 : 400,
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: !item.spendId ? 800 : 400,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: !item.spendId ? 800 : 400,
                  }}
                >
                  {item.spendId}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: !item.spendId ? 800 : 400,
                  }}
                >
                  {index + 1 > 1 && index + 1 < 5 ? (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({ id: item.id, value: e.target.value, name: "value4" })
                      }
                    >
                      <option value="1">USD</option>
                      <option value="2">VND</option>
                    </select>
                  ) : (
                    item.unit
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: !item.spendId ? 800 : 400,
                  }}
                >
                  {isDisabled(item.spendId) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
